<template>
<div class="navigation">
    <el-dialog title="选择图标" :visible.sync="dialogFormVisible">
        <p class="localChoice">电脑本地选择</p>
        <div class="btnBox">
            <el-button type="primary"><label for="upload">本地上传</label></el-button>
            <span class="iconTips">仅支持 .png格式，不大于100KB（系统默认：未选中图标颜色#999999）</span>
        </div>
        <input type="file" id="upload" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImg($event,2)">
        <div class="iconLibrary">
            <p>从图标库选择</p>
            <div class="iconBox">
                <div @click="choiceIcon(item, index)" :class="{'iconItem': true, 'select': selectedIconIndex === index}" v-for="(item, index) in iconData" :key="index">
                    <img v-lazy="item" alt="">
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>
<script>
import {iconImgTextNavs} from 'common/js/icon-url'
import {getUploadParam, qiniuFormUpload} from 'api/api'
import {mapActions} from 'vuex'
export default {
    name: 'navigation',
    data() {
        return {
            dialogFormVisible: false,
            way: '',
            iconData: [],
            selectedIconIndex: null,
            imgUrl: '',
            uploadSetting: {
                localvurl: '', // 本地访问图片地址
                uploadauth: '', // 授权信息
                uploadfilekey: '', // 文件保存名字
                uploadurl: '' // 上传文件地址
            },
            fileOtherInfo: {
                type: 'add',
                keyid: '',
                vsource: 1, // 1自己上传 2素材 3系统默认资源
                furl: ''
            },
            item: {
                barimgurl: '',
                barimgurlsel: ''
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            }
        }
    },
    methods: {
        cancel() {
            this.dialogFormVisible = false
        },
        submit() {
            this.item.banner = {
                keyid: '',
                furl: this.imgUrl
            }
            this.cancel()
        },
        _getUploadParam(file) {
            this.setLoading(true)
            getUploadParam({
                data: Object.assign({}, this.uploadType),
                success: data => {
                    this.uploadSetting = data.data
                    this.fileOtherInfo.furl = this.uploadSetting.localvurl
                    this.setLoading(false)
                    this.uploadFile(file)
                },
                error: data => {
                    this.$message.error('获取参数错误')
                    this.setLoading(false)
                }
            })
        },
        uploadFile(file) {
            let formData = new FormData()
            formData.append('file', file)
            formData.append('key', this.uploadSetting.uploadfilekey)
            formData.append('token', this.uploadSetting.uploadauth)
            qiniuFormUpload({
                url: this.uploadSetting.uploadurl,
                data: formData,
                success: (data) => {
                    this.item.banner = Object.assign({}, data, this.fileOtherInfo)
                    this.cancel()
                },
                error: (data) => {
                    this.$message.error('上传失败，请重新上传')
                }
            })
        },
        uploadImg (e, num) {
            // 上传图片
            var file = e.target.files[0]
            if (!/\.(png|PNG)$/.test(e.target.value)) {
                this.$message.error('图片类型必须是.png')
                return false
            }
            this._getUploadParam(file)
        },
        choiceIcon(url, index) {
            this.imgUrl = url
            this.selectedIconIndex = index
        },
        openDialog(obj) {
            this.dialogFormVisible = true
            this.iconData = iconImgTextNavs()
            this.item = obj
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {}
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
.navigation{
    .localChoice{
        font-weight: 400;
        font-size: 14px;
    }
    .btnBox{
        display: flex;
        align-items: center;
        margin-top: 18px;
        .el-button{
            margin-bottom: 0;
        }
        .iconTips{
            color: #909399;
            margin-left: 14px;
        }
    }
    .iconLibrary{
        margin-top: 24px;
        .iconBox{
            display: flex;
            flex-wrap: wrap;
            margin-top: 15px;
            .iconItem{
                width: 90px;
                height: 90px;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid #DCDFE6;
                box-sizing: border-box;
                margin-bottom: 15px;
                margin-right: 15px;
                cursor: pointer;
                img{
                    width: 30px;
                    height: 30px;
                }
            }
            .select{
                border: 1px solid #409EFF;
            }
        }
    }
}
</style>
